import styles from './HomePageV4.scss';
import { useState } from 'react';
import { Tabs } from 'components/common/Tabs/Tabs';

export const setHomePageTabs = {
    binders: {
        label: 'Binders',
        path: '/binders'
    },
    tasks: {
        label: 'Tasks',
        path: '/tasks'
    },
};

export default function HomePageV4(props) {
    const [tabs] = useState([setHomePageTabs.binders, setHomePageTabs.tasks]);

    return (
        <div className={styles.homepage} data-cy="HomePage">
            <nav className={styles.HomePageNavigation} data-cy="HomePageNavigation">
                <Tabs tabs={tabs} location={location} />
            </nav>
            {props.children}
        </div>
    );
}